// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3ncnc","bigColWidth":"Table_bigColWidth__3apOV","biggerColWidth":"Table_biggerColWidth__2NtZ0","row":"Table_row__1V-kQ","col":"Table_col__3Dq4y"};